<template>
  <header class="site-header" id="header">
    <nav class="navbar navbar-expand-lg transparent-bg static-nav">
      <div class="container">
        <a class="navbar-brand" href="/">
          <img src="/fe/asset/img/logo.png" alt="logo" class="logo-default" />
          <img
            src="/fe/asset/img/logo.png"
            alt="logo"
            style="max-width: 70px"
            class="logo-scrolled"
          />
        </a>
        <div class="collapse navbar-collapse">
          <ul class="navbar-nav ml-auto">
            <Menu />
          </ul>
        </div>
      </div>
      <!--side menu open button-->

      <a
        href="javascript:void(0)"
        class="d-inline-block sidemenu_btn"
        id="sidemenu_toggle"
      >
        <span></span> <span></span> <span></span>
      </a>
    </nav>

    <!-- SIDE MENU -->
    <SideMenu />
    <!-- End side menu -->
  </header>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Menu from "@/components/layouts/navbar/Menu.vue";
import SideMenu from "@/components/layouts/navbar/SideMenu.vue";

export default defineComponent({
  name: "Navbar",
  components: {
    Menu,
    SideMenu,
  },
  setup() {},
});
</script>
